import React from 'react';
import {WingBlank, Cols} from '../../components';
import Link from 'react-router/lib/Link';
import './Solution.less';

function SolutionHoverMask({data: {title, enTitle, img2, description, to}}) {
  return (
    <div className='SolutionHoverMask' style={{background: `url(${img2}) no-repeat center center`}}>
      <Link to={to}>
        <div>
          <div>
            <h2>{title}</h2>
            <div>{enTitle}</div>
            <div/>
            <div>{description.map((item, index) => (<div key={index}>{item}</div>))}</div>
            <div>{`了解更多 >`}</div>
          </div>
        </div>
      </Link>
    </div>
  );
}

function SolutionMobileHoverMask({data: {title, enTitle, img3, description, to}, className, onClick}) {
  return (
    <div className={className} style={{background: `url(${img3}) no-repeat center center`, backgroundSize: '100% 100%'}}>
      <div>
        <div onClick={onClick}>{`>`}</div>
        <div>
          <h2>{title}</h2>
          <div>{enTitle}</div>
          <div/>
          <div>{description.join('')}</div>
          <Link to={to}>{`了解更多 >`}</Link>
        </div>
      </div>
    </div>
  );
}

class SolutionCard extends React.Component {
  state = {className: 'SolutionMobileHoverMask'};

  onCloseMask = (e) => {
    e.stopPropagation();
    this.setState({className: `SolutionMobileHoverMask`});
  };

  onOpenMask = () => {
    this.setState({className: `SolutionMobileHoverMask SolutionMobileHoverMaskActive`});
  };

  render() {
    const {title, enTitle, img} = this.props.data;
    return (
      <div className='SolutionCard' onClick={this.onOpenMask}>
        <div>
          <div>
            <img src={img} alt='image' />
          </div>
          <div>
            <h2>{title}</h2>
            <div>{enTitle}</div>
          </div>
        </div>
        <SolutionHoverMask data={this.props.data} />
        <SolutionMobileHoverMask data={this.props.data} className={this.state.className} onClick={this.onCloseMask}/>
      </div>
    );
  }
}

function Solution(props) {
  return (
    <WingBlank className='Solution'>
      <h1>解决方案</h1>
      <Cols {...props}>
        <SolutionCard />
      </Cols>
    </WingBlank>
  );
}

export default Solution;



// WEBPACK FOOTER //
// ./src/routes/Home/Solution.js